<template>
<section>
    <div class="modal mtn open" tabindex="0" style="z-index: 1003; display: block; opacity: 1; top: 6%; transform: scaleX(1) scaleY(1);">
        <div class="modal-content">
            <div class="row fail cancel">
                <h1 class="text-center" style="margin-top:7rem; text-align: center;width: 100%;">4<span>0</span>4</h1>
                <p class="payment-cancel" style="width: 100%;">We've searched everywhere. <br>This page does not exit on our server <br>please check the link again</p>
                <p class="pay-date" style="width: 100%;">{{ date }}</p>
            </div>
        </div>
    </div>
</section>
</template>

<script>
export default {
    name: 'MTNNotFound',
    data() {
        return {
            date: this.$todaysDate(),
        }
    },
}
</script>